(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ruRU = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Данные не найдены'
      },
      combobox: {
        placeholder: 'Выбрать',
        searchPlaceholder: 'Найти'
      },
      datepicker: {
        apply: 'Применить',
        clearSelection: 'Очистить',
        pickADays: 'Выбрать дни',
        prevYear: 'Прошлый год',
        nextYear: 'Следующий год',
        prevMonth: 'Предыдущий месяц',
        nextMonth: 'Следующий месяц',
        year: '',
        month1: 'Январь',
        month2: 'Февраль',
        month3: 'Март',
        month4: 'Апрель',
        month5: 'Май',
        month6: 'Июнь',
        month7: 'Июль',
        month8: 'Август',
        month9: 'Сентябрь',
        month10: 'Октябрь',
        month11: 'Ноябрь',
        month12: 'Декабрь',
        weeks: {
          sun: 'Вс',
          mon: 'Пн',
          tue: 'Вт',
          wed: 'Ср',
          thu: 'Чт',
          fri: 'Пт',
          sat: 'Сб'
        },
        months: {
          jan: 'Янв',
          feb: 'Фев',
          mar: 'Мар',
          apr: 'Апр',
          may: 'Май',
          jun: 'Июн',
          jul: 'Июл',
          aug: 'Авг',
          sep: 'Сен',
          oct: 'Окт',
          nov: 'Ноя',
          dec: 'Дек'
        },
        pickADay: 'Выберите день'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Данные не найдены'
      },
      filepicker: {
        browse: 'Обзор',
        select: 'Выбрать файл'
      },
      filter: {
        apply: 'Применить',
        cancel: 'Отмена',
        filterButton: 'Фильтр',
        reset: 'Сбросить фильтры',
        resetDefault: 'Сбросить'
      },
      search: {
        noDataMessage: 'Данные не найдены'
      },
      'multi-search': {
        'separator-and': 'И',
        'search-button': 'Найти',
        'search-placeholder': 'Поиск по имени'
      },
      select: {
        all: 'Все',
        clearSelection: 'Очистить выбор',
        noMatch: 'Данные не найдены',
        noData: 'Нет данных',
        placeholder: 'Выбрать',
        item: 'элемент.',
        selected: 'выбрано',
        found: 'найдено'
      },
      upload: {
        browseButton: 'Обзор',
        text: 'Перетащите файлы для передачи или щелкните "Обзор"',
        tip: 'Можно передать 10 файлов размером до 25 МБ каждый'
      },
      table: {
        emptyText: 'Нет данных'
      },
      tree: {
        emptyText: 'Нет данных'
      }
    }
  };
  _exports.default = _default;
});